import { render, staticRenderFns } from "./compose-user.vue?vue&type=template&id=1595dd36"
import script from "./compose-user.vue?vue&type=script&lang=ts"
export * from "./compose-user.vue?vue&type=script&lang=ts"
import style0 from "./compose-user.vue?vue&type=style&index=0&id=1595dd36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports